module.exports = __webpack_public_path__ + "static/img/daikaipiao@3x1085f18.png";